import { useMemo } from 'react'

import { GetWorkplaceLocationsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface WorkplaceGeo {
  country: string
}

/**
 * Fetches geographic data (country) for a set of workplace (Location) IDs.
 * Returns a map from workplace ID to its geographic data.
 */
export const useWorkplaceGeo = (workplaceIds: string[], enabled = true) => {
  const uniqueIds = useMemo(() => [...new Set(workplaceIds.filter(Boolean))], [workplaceIds])

  const { data, loading } = useQuery(GetWorkplaceLocationsDocument, {
    variables: { ids: uniqueIds },
    skip: !enabled || uniqueIds.length === 0,
  })

  const geoByWorkplaceId = useMemo(() => {
    const map = new Map<string, WorkplaceGeo>()
    const nodes = data?.locations?.locationsConnection?.nodes ?? []
    for (const node of nodes) {
      if (node?.id && node?.country) {
        map.set(String(node.id), {
          country: node.country,
        })
      }
    }
    return map
  }, [data])

  return { geoByWorkplaceId, loading }
}
